import React, { useMemo } from 'react';
import { View, StyleSheet, ViewStyle, TextStyle } from 'react-native';
import { Text } from '@/components/common/text';
import { useMarketplaceColors } from '@/constants/residents/marketplaceColors';

interface StatItemProps {
  value: number;
  label: string;
  valueStyle?: TextStyle;
  labelStyle?: TextStyle;
  containerStyle?: ViewStyle;
}

export const StatItem: React.FC<StatItemProps> = ({
  value,
  label,
  valueStyle,
  labelStyle,
  containerStyle,
}) => {
  const mc = useMarketplaceColors();

  const styles = useMemo(() => StyleSheet.create({
    container: {
      alignItems: 'center',
    },
    value: {
      fontSize: 14,
      fontWeight: '500',
      color: mc.textPrimary,
      lineHeight: 21,
      textAlign: 'center',
    },
    label: {
      fontSize: 14,
      fontWeight: '400',
      color: mc.textSecondary,
      lineHeight: 21,
      textAlign: 'center',
    },
  }), [mc]);

  return (
    <View style={[styles.container, containerStyle]}>
      <Text style={[styles.value, valueStyle]}>{value}</Text>
      <Text style={[styles.label, labelStyle]}>{label}</Text>
    </View>
  );
};

